import React, { useEffect, useState } from 'react';
import { Modal, Tree, Result, Spin, Icon } from 'antd';
import axios from 'axios';
import { displayErrors } from '../../config/display';
import { headers } from '../../config/token';
import { API } from '../../config/config';

const overallStyles = `
@keyframes overall-fadeIn {
  from { opacity: 0; transform: translateY(8px); }
  to { opacity: 1; transform: translateY(0); }
}
@keyframes overall-slideUp {
  from { opacity: 0; transform: scale(0.98) translateY(15px); }
  to { opacity: 1; transform: scale(1) translateY(0); }
}
@keyframes overall-shimmer {
  0% { background-position: -1000px 0; }
  100% { background-position: 1000px 0; }
}
@keyframes overall-float {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-2px); }
}
@keyframes overall-treeFade {
  from { opacity: 0; transform: translateX(-10px); }
  to { opacity: 1; transform: translateX(0); }
}

/* Modal Overrides */
.overall-modal .ant-modal-content {
  border-radius: 16px !important;
  overflow: hidden !important;
  box-shadow: 0 24px 48px rgba(0,0,0,0.12), 0 0 0 1px rgba(8,145,178,0.1) !important;
  animation: overall-slideUp 0.3s cubic-bezier(0.22, 1, 0.36, 1) both !important;
}
.overall-modal .ant-modal-header {
  background: linear-gradient(135deg, #0c4e6e 0%, #0891b2 40%, #06b6d4 75%, #22d3ee 100%) !important;
  padding: 18px 24px !important;
  border-bottom: none !important;
  position: relative;
  overflow: hidden;
}
.overall-modal .ant-modal-header::before {
  content: '';
  position: absolute;
  inset: 0;
  background-image: radial-gradient(rgba(255,255,255,0.08) 1px, transparent 1px);
  background-size: 24px 24px;
  pointer-events: none;
}
.overall-modal .ant-modal-header::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(90deg, #22d3ee, #06b6d4, #0891b2, #0c4e6e, #22d3ee);
  background-size: 300% auto;
  animation: overall-shimmer 3s linear infinite;
}
.overall-modal .ant-modal-title {
  color: #fff !important;
  font-weight: 700;
  font-size: 16px;
  letter-spacing: 0.5px;
}
.overall-modal .ant-modal-close {
  top: 16px !important;
  right: 20px !important;
  color: rgba(255,255,255,0.8) !important;
  transition: all 0.3s cubic-bezier(0.22, 1, 0.36, 1) !important;
}
.overall-modal .ant-modal-close:hover {
  color: #fff !important;
  transform: rotate(90deg) scale(1.1) !important;
}
.overall-modal .ant-modal-close .ant-modal-close-x {
  width: 36px !important;
  height: 36px !important;
  line-height: 36px !important;
}
.overall-modal .ant-modal-body {
  padding: 0 !important;
  background: #f8fafc;
}
.overall-modal .ant-modal-footer {
  display: none !important;
}

/* Header Icon & Title */
.overall-header-icon {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  margin-right: 8px;
}
.overall-icon-wrap {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: rgba(255,255,255,0.15);
  border: 1.5px solid rgba(255,255,255,0.3);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
  animation: overall-float 3s ease-in-out infinite;
}
.overall-title-main {
  font-size: 16px;
  font-weight: 800;
  letter-spacing: 0.8px;
}
.overall-title-sub {
  font-size: 11px;
  color: rgba(255,255,255,0.75);
  letter-spacing: 0.5px;
  margin-top: 2px;
  font-weight: 400;
}

/* Content Area */
.overall-content {
  padding: 20px 24px 24px;
  background: #f8fafc;
}

/* Info Card - Job Order Summary */
.overall-info-card {
  background: linear-gradient(135deg, #ffffff 0%, #f0f9ff 100%);
  border-radius: 12px;
  padding: 16px 20px;
  margin-bottom: 20px;
  border: 1px solid #a5f3fc;
  box-shadow: 0 2px 8px rgba(0,0,0,0.04);
  transition: all 0.2s ease;
}
.overall-info-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(8,145,178,0.1);
  border-color: #67e8f9;
}
.overall-info-label {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  color: #0891b2;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  gap: 8px;
}
.overall-info-value {
  font-size: 14px;
  font-weight: 600;
  color: #2d2d2d;
  display: flex;
  align-items: baseline;
  gap: 8px;
  flex-wrap: wrap;
}
.overall-info-badge {
  background: #e0f2fe;
  color: #0891b2;
  padding: 2px 10px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 600;
}

/* Tree Customization */
.overall-tree-wrapper {
  background: #ffffff;
  border-radius: 12px;
  border: 1px solid #a5f3fc;
  overflow: hidden;
  transition: all 0.2s ease;
  max-height: 60vh;
  overflow-y: auto;
}
.overall-tree-wrapper:hover {
  border-color: #67e8f9;
  box-shadow: 0 4px 12px rgba(8,145,178,0.08);
}
.overall-modal .ant-tree {
  background: transparent !important;
  padding: 16px 20px !important;
  font-size: 13px !important;
}
.overall-modal .ant-tree .ant-tree-treenode {
  padding: 4px 0 !important;
  transition: all 0.2s ease;
}
.overall-modal .ant-tree .ant-tree-treenode:hover {
  background: #f0f9ff !important;
}
.overall-modal .ant-tree-node-content-wrapper {
  padding: 6px 8px !important;
  border-radius: 8px !important;
  transition: all 0.2s ease !important;
}
.overall-modal .ant-tree-node-content-wrapper:hover {
  background: #e0f2fe !important;
}
.overall-modal .ant-tree .ant-tree-title {
  font-weight: 500;
  color: #374151;
  font-size: 13px;
}
.overall-modal .ant-tree .ant-tree-switcher {
  width: 28px !important;
  height: 28px !important;
  line-height: 28px !important;
  color: #06b6d4 !important;
  transition: all 0.2s ease;
}
.overall-modal .ant-tree .ant-tree-switcher:hover {
  background: #e0f2fe !important;
  border-radius: 6px !important;
}
.overall-modal .ant-tree .ant-tree-iconEle {
  width: 24px !important;
  height: 24px !important;
  line-height: 24px !important;
  color: #06b6d4 !important;
}
.overall-modal .ant-tree .ant-tree-node-selected {
  background: linear-gradient(135deg, #e0f2fe 0%, #bae6fd 100%) !important;
  border-radius: 8px !important;
}
.overall-modal .ant-tree .ant-tree-node-selected .ant-tree-title {
  color: #0c4e6e !important;
  font-weight: 600 !important;
}

/* Tree Node Styling - Different levels */
.overall-modal .ant-tree-treenode[data-level="0"] .ant-tree-title {
  font-weight: 700 !important;
  color: #0c4e6e !important;
  font-size: 14px !important;
}
.overall-modal .ant-tree-treenode[data-level="1"] .ant-tree-title {
  font-weight: 600 !important;
  color: #0891b2 !important;
}
.overall-modal .ant-tree-treenode[data-level="2"] .ant-tree-title {
  font-weight: 500 !important;
  color: #06b6d4 !important;
}

/* Tree Line Customization */
.overall-modal .ant-tree-show-line .ant-tree-switcher {
  background: transparent !important;
}
.overall-modal .ant-tree-show-line .ant-tree-indent-unit {
  border-right: 1px solid #a5f3fc !important;
}

/* Empty State */
.overall-empty {
  text-align: center;
  padding: 48px 24px;
  background: #ffffff;
  border-radius: 12px;
  border: 1px solid #a5f3fc;
}
.overall-empty-icon {
  font-size: 48px;
  color: #67e8f9;
  margin-bottom: 16px;
}
.overall-empty-text {
  color: #0891b2;
  font-size: 14px;
  font-weight: 600;
}
.overall-empty-sub {
  font-size: 12px;
  color: #94a3b8;
  margin-top: 8px;
}

/* Loading Overlay */
.overall-modal .ant-spin-nested-loading {
  min-height: 200px;
}
.overall-modal .ant-spin-blur {
  opacity: 0.5;
}
.overall-modal .ant-spin-dot {
  color: #06b6d4 !important;
}
.overall-modal .ant-spin-dot i {
  background-color: #06b6d4 !important;
}

/* Scrollbar Styling */
.overall-tree-wrapper::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}
.overall-tree-wrapper::-webkit-scrollbar-track {
  background: #e0f2fe;
  border-radius: 10px;
}
.overall-tree-wrapper::-webkit-scrollbar-thumb {
  background: #67e8f9;
  border-radius: 10px;
}
.overall-tree-wrapper::-webkit-scrollbar-thumb:hover {
  background: #22d3ee;
}

/* Result Component Override */
.overall-modal .ant-result {
  background: #ffffff;
  border-radius: 12px;
  padding: 40px;
}
.overall-modal .ant-result .ant-result-title {
  color: #0c4e6e;
  font-weight: 600;
}
.overall-modal .ant-result .ant-result-subtitle {
  color: #0891b2;
}
.overall-modal .ant-result .ant-result-icon {
  color: #67e8f9;
}
`;

const OverallDetailsModal = props => {
  const {
    setOverallDetails,
    overallDetails: {
      visible,
      id,
      item
    },
  } = props;

  const [tree, setTrees] = useState({ treeData: [], treeDataParentKeys: [] });
  const [isLoading, setLoading] = useState(false);
  
  useEffect(() => {
    if (visible && id) {
      setLoading(true);
      axios.get(API + `cposms/poitems/overall/${id}`, headers())
        .then(res => {
          const { treeData, treeDataParentKeys } = res.data;
          setTrees({
            treeData: treeData || [],
            treeDataParentKeys: treeDataParentKeys || []
          });
        })
        .catch(err => {
          displayErrors(err);
          setTrees({ treeData: [], treeDataParentKeys: [] });
        })
        .finally(() => setLoading(false));
    }
  }, [visible, id]);

  // Calculate tree statistics
  const getTreeStats = () => {
    if (!tree.treeData || tree.treeData.length === 0) return null;
    
    const countNodes = (nodes) => {
      let count = 0;
      nodes.forEach(node => {
        count++;
        if (node.children && node.children.length > 0) {
          count += countNodes(node.children);
        }
      });
      return count;
    };
    
    const nodeCount = countNodes(tree.treeData);
    const levelCount = () => {
      let maxLevel = 0;
      const traverse = (nodes, level = 0) => {
        nodes.forEach(node => {
          maxLevel = Math.max(maxLevel, level);
          if (node.children && node.children.length > 0) {
            traverse(node.children, level + 1);
          }
        });
      };
      traverse(tree.treeData);
      return maxLevel;
    };
    
    return {
      nodeCount,
      maxLevel: levelCount() + 1,
      rootCount: tree.treeData.length
    };
  };

  const stats = getTreeStats();

  return (
    <>
      <style>{overallStyles}</style>
      <Modal
        className="overall-modal"
        style={{ top: 20 }}
        title={
          <div className="overall-header-icon">
            <div className="overall-icon-wrap">
              <Icon type="profile" style={{ fontSize: 18, color: '#fff' }} />
            </div>
            <div>
              <div className="overall-title-main">
                JOB ORDER DETAILS
              </div>
              <div className="overall-title-sub">
                {item ? item.toString().toUpperCase() : 'VIEW DETAILS'}
              </div>
            </div>
          </div>
        }
        visible={visible}
        width="75%"
        onCancel={() => isLoading ? null : setOverallDetails({ visible: false })}
        footer={null}
      >
        <div className="overall-content">
          {/* Summary Card */}
          {tree.treeData.length > 0 && stats && (
            <div className="overall-info-card">
              <div className="overall-info-label">
                <Icon type="info-circle" style={{ fontSize: 12 }} />
                JOB ORDER SUMMARY
              </div>
              <div className="overall-info-value">
                <span className="overall-info-badge">
                  <Icon type="folder-open" style={{ fontSize: 10, marginRight: 4 }} />
                  {stats.rootCount} Main {stats.rootCount === 1 ? 'Category' : 'Categories'}
                </span>
                <span className="overall-info-badge">
                  <Icon type="share-alt" style={{ fontSize: 10, marginRight: 4 }} />
                  {stats.nodeCount} Total {stats.nodeCount === 1 ? 'Item' : 'Items'}
                </span>
                <span className="overall-info-badge">
                  <Icon type="menu-unfold" style={{ fontSize: 10, marginRight: 4 }} />
                  {stats.maxLevel} {stats.maxLevel === 1 ? 'Level' : 'Levels'}
                </span>
              </div>
            </div>
          )}

          {/* Tree Section */}
          <div className="overall-tree-wrapper">
            <Spin spinning={isLoading}>
              {tree.treeData.length > 0 ? (
                <Tree
                  blockNode={true}
                  defaultExpandAll={true}
                  treeData={tree.treeData}
                  showLine
                  onExpand={(expandedKeys, { expanded, node }) => {
                    // Optional: Add expand/collapse tracking if needed
                    console.log('Node expanded:', node.props.title, expanded);
                  }}
                  onSelect={(selectedKeys, { selected, selectedNodes, node }) => {
                    // Optional: Add selection handling if needed
                    console.log('Selected:', selectedKeys);
                  }}
                />
              ) : (
                !isLoading && (
                  <div className="overall-empty">
                    <div className="overall-empty-icon">
                      <Icon type="inbox" />
                    </div>
                    <div className="overall-empty-text">
                      NO JOB ORDER FOUND
                    </div>
                    <div className="overall-empty-sub">
                      No job order items available for this purchase order
                    </div>
                  </div>
                )
              )}
            </Spin>
          </div>

          {/* Footer note */}
          {tree.treeData.length > 0 && (
            <div style={{
              marginTop: 12,
              fontSize: 11,
              color: '#0891b2',
              textAlign: 'center',
              padding: '8px',
              opacity: 0.7
            }}>
              <Icon type="bulb" style={{ fontSize: 11, marginRight: 6 }} />
              Click on any item to view detailed information
            </div>
          )}
        </div>
      </Modal>
    </>
  );
};

export default OverallDetailsModal;